export const CORE = {
  UPDATE_BRANCH: 'core/UPDATE_BRANCH',
  SET_LANG: 'core/SET_LANG',
  SET_USER: 'core/SET_USER',
  SET_MENU: 'core/SET_MENU',
  READY: 'core/READY',
  // Session
  RECEIVE_USER_SESSION: 'core/RECEIVE_USER_SESSION',
  RECEIVE_TENANT_SESSION: 'core/RECEIVE_TENANT_SESSION'
}

export const DATA = {
  // Global
  SET_VALIDATION_ERRORS: 'data/VALIDATION_ERRORS',
  REMOVE_VALIDATION_ERRORS: 'data/REMOVE_VALIDATION_ERRORS',
  // Members
  RECEIVE_MEMBERS: 'data/RECEIVE_MEMBERS',
  UPDATE_ACTIVE_MEMBER: 'data/UPDATE_ACTIVE_MEMBER',
  SET_GROUP_FOR_SEARCH: 'data/SET_GROUP_FOR_SEARCH',
  RECEIVE_SEARCH_OPERATIONS: 'data/RECEIVE_SEARCH_OPERATIONS',
  RECEIVE_INTERNAL_DATA_FIELDS: 'data/RECEIVE_INTERNAL_DATA_FIELDS',
  RECEIVE_MEMBER_AUDIT_LOGS: 'data/RECEIVE_MEMBER_AUDIT_LOGS',
  RECEIVE_HISTORY: 'data/RECEIVE_HISTORY',
  UPDATE_ACTIVE_INVOICE: 'data/UPDATE_ACTIVE_INVOICE',
  RECEIVE_SAVED_SEARCH_CRITERIAS: 'data/RECEIVE_SAVED_SEARCH_CRITERIAS',
  // Groups
  RECEIVE_GROUPS: 'data/RECEIVE_GROUPS',
  UPDATE_ACTIVE_GROUP: 'data/UPDATE_ACTIVE_GROUP',
  RECEIVE_DATATYPES: 'data/RECEIVE_DATATYPES',
  // Payment options
  RECEIVE_PAYMENT_OPTIONS: 'data/PAYMENT_OPTIONS',
  UPDATE_ACTIVE_PAYMENT_OPTION: 'data/UPDATE_ACTIVE_PAYMENT_OPTION',
  RECEIVE_REPEATS_TYPE: 'data/RECEIVE_REPEATS_TYPE',
  // Taxes
  RECEIVE_TAXES: 'data/RECEIVE_TAXES',
  UPDATE_ACTIVE_TAX: 'data/UPDATE_ACTIVE_TAX',
  // Users
  RECEIVE_USERS: 'data/RECEIVE_USERS',
  UPDATE_ACTIVE_USER: 'data/UPDATE_ACTIVE_USER',
  // Campaigns - Links - reports
  RECEIVE_CAMPAIGNS: 'data/RECEIVE_CAMPAIGNS',
  UPDATE_ACTIVE_CAMPAIGN: 'data/UPDATE_ACTIVE_CAMPAIGN',
  RECEIVE_CAMPAIGN_REPORT: 'data/RECEIVE_CAMPAIGN_REPORT',
  RECEIVE_LINKS: 'data/RECEIVE_LINKS',
  RECEIVE_CAMPAIGN_CLICKS: 'data/RECEIVE_CAMPAIGN_CLICKS',
  RECEIVE_CAMPAIGN_OPENS: 'data/RECEIVE_CAMPAIGN_OPENS',
  // Templates
  RECEIVE_TEMPLATES: 'data/RECEIVE_TEMPLATES',
  UPDATE_ACTIVE_TEMPLATE: 'data/UPDATE_ACTIVE_TEMPLATE',
  // Notifcations
  RECEIVE_NOTIFICATION: 'data/RECEIVE_NOTIFICATION',
  REMOVE_NOTIFICATION: 'data/REMOVE_NOTIFICATION'
}

export const VIEWS = {
  SET_STATE: 'views/SET_STATE',
  READY: 'views/READY'
}

export const MENU = {
  SET_LANG: 'menu/SET_LANG',
  SET_USER: 'menu/SET_USER',
  TOGGLE: 'menu/TOGGLE',
  CLOSE: 'menu/CLOSE'
}



// WEBPACK FOOTER //
// ./scripts/store/mutations.js